import { Modal } from '@design-system/components/modal/modal';
import { useEffect, useState } from 'react';
import { Input } from '@design-system/components/input/input';
import { Typography } from '@design-system/components/typography/typography';
import { _noop } from '@client/new/helpers/general';

export const ExtrasTabModal = (p: {
  mode: 'create' | 'edit';
  value: string;
  isOpen: boolean;
  onSubmit: (value: string) => void;
  onClose: () => void;
}) => {
  const [input, setInput] = useState<string>('Extras');

  useEffect(() => {
    setInput(p.value || 'Extras');
  }, [p.value]);
  return (
    <Modal
      isOpen={p.isOpen}
      onClose={p.onClose}
      title="Name your Extras"
      modalClassName="w-full md:max-w-[572px]"
      primaryCta={{
        caption: 'Save',
        onClick: () => p.onSubmit(input || 'Extras'),
      }}
      secondaryCta={{
        caption: 'Cancel',
        onClick: p.onClose,
      }}
      stretchCta
    >
      <Typography variant="body" fontWeight="normal">
        You are about to create an new space in Extras that will display as a
        separate tab in your consumer app.
      </Typography>
      <Typography variant="body" fontWeight="normal">
        Customize name of this tab. By default it’s called Extras.
      </Typography>
      <Input
        value={input}
        onChange={(e) => setInput(e.target.value)}
        placeholder="Extras"
        className="w-full"
        autoFocus
      />
    </Modal>
  );
};
